// Services/fetchCreateOrder.js
import { ORDERS } from "../Constants/Endpoints";
import { ApiRequestInterceptor } from "./apiRequest";

// --- helpers para leer/decodificar el JWT del login ---
function getLoginData() {
  try {
    const raw = localStorage.getItem("logindata");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function getToken() {
  const login = getLoginData();
  // Ajusta según cómo guardes la respuesta del login
  return (login && (login.token || (login.data && login.data.token))) || null;
}

function decodeJwtPayload(token) {
  if (!token) return null;
  try {
    const parts = token.split(".");
    if (parts.length < 2) return null;
    const payload = parts[1];
    const b64 = payload.replace(/-/g, "+").replace(/_/g, "/");

    const base64Decode =
      typeof atob === "function"
        ? atob
        : (str) => Buffer.from(str, "base64").toString("binary");

    const json = base64Decode(b64);
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export const fetchCreateOrder = async (restauranteId, body) => {
  const method = "POST";
  const endpoint = ORDERS.createOrder.replace("{restauranteId}", restauranteId);

  // ⬇️ extrae name/email/phone/userId del JWT y mézclalos en el body
  const token = getToken();
  const payload = decodeJwtPayload(token) || {};

  const enrichedBody = {
    ...body,
    payer: {
      ...(body && body.payer ? body.payer : {}),
      email: payload.email || (body && body.payer && body.payer.email) || "",
    },
    metadata: {
      ...(body && body.metadata ? body.metadata : {}),
      cliente: payload.name || (body && body.metadata && body.metadata.cliente) || "Anonimo",
      telefono: payload.phone || (body && body.metadata && body.metadata.telefono) || "",
      userId: payload.userId || (body && body.metadata && body.metadata.userId) || undefined,
    },
  };

  const response = await ApiRequestInterceptor(endpoint, method, enrichedBody);
  // ApiRequestInterceptor -> { code, data }

  const httpCode = response?.code ?? 500;
  const data = response?.data ?? {};

  const statusCode = httpCode;
  const message = data?.message || null;
  const code = data?.code || null;        // 👈 AQUÍ VIENE "USER_BLOCKED"
  const order = data?.order || null;
  const whatsapp = data?.whatsapp || null;
  const pendingDebt = Number(data?.pendingDebt) || 0; // deuda de un no-show anterior

  return {
    statusCode,
    message,
    code,      // 👈 importante para el front (HacerPedido)
    order,
    whatsapp,
    pendingDebt,
    raw: response,
  };
};